import { render } from "./PractiseTask.vue?vue&type=template&id=de3fe4a6"
import script from "./PractiseTask.vue?vue&type=script&lang=js"
export * from "./PractiseTask.vue?vue&type=script&lang=js"

import "./PractiseTask.vue?vue&type=style&index=0&id=de3fe4a6&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__